import { type DashboardDto } from '../../services/api';
import { renderDashboardMarkup } from './dashboard-shared';

export class RcDashboardView extends HTMLElement {
  data: DashboardDto | null = null;

  render(): void {
    if (!this.data) return;
    this.innerHTML = renderDashboardMarkup(this.data);
  }
}

if (!customElements.get('rc-dashboard-view')) {
  customElements.define('rc-dashboard-view', RcDashboardView);
}
